export enum RouterActionType {
  UpdateRoute = 'UpdateRoute',
}
